import React from 'react';

import { Box, Typography } from '@mui/material';

import { useResponsiveLayout } from '@/hooks/useResponsiveLayout';

import { OmniSearchBox, EXAMPLE_TOPICS, EXAMPLE_QUESTIONS } from '../OmniSearchBox';

interface OmniBoxExpandedProps {
  onClose: () => void;
}

// Wrapper component for OmniSearchBox with updated instructions
export const OmniBoxExpanded: React.FC<OmniBoxExpandedProps> = ({ onClose }) => {
  const { isNarrowScreen } = useResponsiveLayout();

  // Updated instructions for the new OmniBox context
  const instructions = isNarrowScreen
    ? 'Search for products or start new conversation'
    : 'Search for products or start new conversation • Use @ to tag friends or give @feedback';

  return (
    <OmniSearchBox
      onClose={onClose}
      example_topics={EXAMPLE_TOPICS}
      example_questions={EXAMPLE_QUESTIONS}
    />
  );
};
